module.exports = __webpack_public_path__ + "img/renewal.1d9113df.jpg";